import { Link } from "gatsby"

import { Img } from "../../../../layout/Img"

export const ResourcesCard = ({ resources }) => {
  return (
    <section className="container flex flex-col items-center justify-center mx-auto">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-3 sm:grid-cols-2">
        {resources?.map((item, key) => (
          <Link key={key} to={`/${item.uri}`}>
            <div className="overflow-hidden rounded">
              {/*  aspect-w-6 aspect-h-4 md:aspect-w-7 md:aspect-h-4 */}
              <div className="relative">
                <Img
                  className="h-60"
                  image={item.coverPicture[0]}
                />

                <div className="absolute top-0 bottom-0 left-0 right-0 h-full transition duration-300 opacity-25 hover:bg-transparent bg-secondary" />
              </div>
              <div className="px-6 py-4">
                <h3 className="inline-block mt-3 text-lg font-semibold transition duration-500 ease-in-out text-secondary lg:text-xl hover:text-primary">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center justify-start gap-4 px-6 pt-4 align-bottom">
                <div className="w-10 rounded-full">
                  <Img
                    className="rounded-full"
                    image={item.authorProfile[0]?.profilePicture[0]}
                    imgStyle={{ borderRadius: '100%' }}
                  />
                </div>

                <h4>{item.authorProfile[0]?.title}</h4>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  )
}
